/**
 * @readonly
 */
export const Microsites = Object.freeze({
  EHERS_ENROLLMENT: 'ehers_enrollment',
  TEST_SITE: 'test_site',
});

/**
 * @readonly
 */
export const Tenants = Object.freeze({
  ALABAMA_POWER_CO: 'alabama_power_co',
  UTILITYCO: 'utilityco',
});

// eslint-disable-next-line no-unused-vars
const TenantValues = Object.values(Tenants);

// declare type based on values in TenantValues
/** @typedef {typeof TenantValues[number]} TenantEnum */
